import { LoadingSpan } from '@uturn/portal/components';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@uturn/ui-kit';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { Financials } from './financials';

export function FinancialsSheet({
	shipmentNumber,
	openSheet,
	setOpenSheet,
}: {
	openSheet: boolean;
	setOpenSheet: (open: boolean) => void;
	shipmentNumber: string;
}) {
	const { t } = useTranslation();

	return (
		<Sheet open={openSheet} onOpenChange={setOpenSheet}>
			<SheetContent>
				<SheetHeader>
					<SheetTitle>
						<h2 className="text-secondary-800 mb-2 text-2xl font-bold">
							{t('pages.shipment-detail.sheet.financials.title', 'Financials')}
						</h2>
					</SheetTitle>
				</SheetHeader>
				<Financials shipmentId={shipmentNumber} />
			</SheetContent>
		</Sheet>
	);
}
